class Finder {
  getIdsRecursive(elements) {
    let ids = [];
    Array.from(elements).forEach(element => {
      ids = ids.concat(this.getIdsRecursive(element.children));
      if (element.id) {
        ids.push(element.id);
      }
    });
    return ids;
  }
}
const finder = new Finder();
export default finder;